<script>
import { mapActions } from "vuex";

const DEPOSIT = Object.freeze({
  CASH_TRANSFER: {
    value: 'CASH_TRANSFER',
    label: 'Cash Deposit',
    description: null
  },
  BANK_GUARANTEE: {
    value: 'BANK_GUARANTEE',
    label: 'Bank Guarantee',
    description: null,
  },
  DEPOSIT_BOND: {
    value: 'DEPOSIT_BOND',
    label: 'Deposit Bond',
    description: null,
  },
  DEPOSIT_BOND_INFO: {
    value: 'DEPOSIT_BOND_INFO',
    label: 'Interested in using a deposit bond but don\'t know how*',
    description: '* By selecting this, you and your client consent to their contact details being shared with our deposit bond partner',
  }
});

export default {
  data() {
    return {
      stripe: "",
      DEPOSIT,
      checkout: "",
      checkoutDisplayed: false,
      clientSecret: "",
      num: 1,
      purchasingEntity: "",
      checked: false,
      privateMode: false,

      reservationFormRules: {
        infoFromDepositBondPartner: false,
        depositPayingMethod: [
          { required: true, message:"Please select a deposit payment method", trigger: "none" }
        ],
        allPurchaser: {
          0: {
            title: [
              { required: true, message: "Please enter title", trigger: "none" }
            ],
            firstName: [
              {
                required: true,
                message: "Please enter first name",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            surName: [
              {
                required: true,
                message: "Please enter surname",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            address: [
              {
                required: true,
                message: "Please enter address",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            suburb: [
              {
                required: true,
                message: "Please enter suburb",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            state: [
              { required: true, message: "Please enter state", trigger: "none" }
            ],
            postcode: [
              {
                required: true,
                message: "Please enter postcode",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            email: [
              {
                required: true,
                message: "Please enter email",
                trigger: "none"
              },
              {
                type: "email",
                message: "Please enter a valid email",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ]
          },
          1: {
            title: [
              { required: true, message: "Please enter title", trigger: "none" }
            ],
            firstName: [
              {
                required: true,
                message: "Please enter first name",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            surName: [
              {
                required: true,
                message: "Please enter surname",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            address: [
              {
                required: true,
                message: "Please enter address",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            suburb: [
              {
                required: true,
                message: "Please enter suburb",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            state: [
              { required: true, message: "Please enter state", trigger: "none" }
            ],
            postcode: [
              {
                required: true,
                message: "Please enter postcode",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ],
            email: [
              {
                required: true,
                message: "Please enter email",
                trigger: "none"
              },
              {
                type: "email",
                message: "Please enter a valid email",
                trigger: "none"
              },
              { validator: this.validateNotOnlySpaceInputs, trigger: "none" }
            ]
          }
        },
        payment: {
          offerAmount: [
            { required: false, trigger: 'blur' },
            { type: 'number', message: 'Offer amount must be a number', trigger: 'change' },
            { validator: this.validateOfferAmount, trigger: "blur" }
          ]
        }
      },
      reservationForm: {
        depositPayingMethod: null,
        infoFromDepositBondPartner: false,
        colourSchemeCollection: "",
        additionalComments: "",
        allPurchaser: [
          {
            purchaserId: 1,
            title: "",
            titleWarn: false,
            open: false,
            state: "",
            stateWarn: false,
            openState: false,
            firstName: "",
            fristWarn: false,
            middleName: "",
            midWarn: false,
            surName: "",
            surWarn: false,
            address: "",
            addressWarn: false,
            suburb: "",
            suburbWarn: false,
            mobile: "",
            mobileWarn: false,
            email: "",
            postcode: "",
            postcodeWarn: false,
            emailwarn: false
          }
        ],
        legal: {
          companyName: "",
          companyWarn: false,
          person: "",
          firstName: "",
          lastName: "",
          personWarn: false,
          address: "",
          addressWarn: false,
          suburb: "",
          suburbWarn: false,
          state: "",
          stateWarn: false,
          postcode: "",
          postcodeWarn: false,
          openState: false,
          email: "",
          emailWarn: false,
          mobile: "",
          mobileWarn: false,
          phone: "",
          phoneWarn: false
        },
        purchaser: {
          title: "",
          firstName: "",
          surname: "",
          address: "",
          suburb: "",
          state: "",
          postcode: "",
          phone: "",
          email: "",
          purchasingEntity: ""
        },
        conveyancerOrSolicitor: {
          isUnifiProvided: false,
          companyName: "",
          contactPerson: "",
          address: "",
          suburb: "",
          state: "",
          postcode: "",
          phone: "",
          email: ""
        },
        executed: {
          name: "",
          date: ""
        },
        agent: {
          companyName: "VARO Property",
          contactPerson: "Craig Chrystie",
          address: "123 Real St",
          suburb: "Sydney",
          state: "New South Wales",
          postcode: "2000",
          phoneNumber: "0412 345 678",
          email: "craig@varo.com",
          singleLineAddress: ""
        },
        payment: {
          offerAmount: "",
          cardName: "",
          cardNumber: "",
          exp: "",
          cvv: ""
        }
      },
      titles: [
        {
          id: 1,
          title: "Mr"
        },
        {
          id: 2,
          title: "Mrs"
        },
        {
          id: 3,
          title: "Miss"
        },
        {
          id: 4,
          title: "Ms"
        },
        {
          id: 5,
          title: "Dr"
        }
      ],
      listingStates: [
        {
          id: 1,
          shortName: "ACT",
          stateName: "Australian Capital Territory"
        },
        {
          id: 2,
          shortName: "NSW",
          stateName: "New South Wales"
        },
        {
          id: 3,
          shortName: "NT",
          stateName: "Northern Territory"
        },
        {
          id: 4,
          shortName: "QLD",
          stateName: "Queensland"
        },
        {
          id: 5,
          shortName: "SA",
          stateName: "South Australia"
        },
        {
          id: 6,
          shortName: "TAS",
          stateName: "Tasmania"
        },
        {
          id: 7,
          shortName: "VIC",
          stateName: "Victoria"
        },
        {
          id: 8,
          shortName: "WA",
          stateName: "Western Australia"
        }
      ]
    };
  },
  props: {
    listingDetails: Object
  },
  created() {
    localStorage.removeItem("email");
    localStorage.removeItem("fname");
    localStorage.removeItem("sname");
    localStorage.removeItem("id");

    if (this.$route.path.slice(0,9) === '/private/') {
      this.privateMode = true;
    }
  },
  components: {},
  methods: {
    ...mapActions("property", [
      "submitReservationInfo",
      "makeReservation",
    ]),
    addAnotherPurchaser() {
      var that = this;
      // set the max number of purchasers
      if (that.num > 1) {
        return false;
      }
      that.num++;
      that.reservationForm.allPurchaser.push({
        purchaserId: that.num,
        title: "",
        open: false,
        state: "",
        openState: false,
        firstName: "",
        middleName: "",
        surName: "",
        address: "",
        suburb: "",
        mobile: "",
        email: "",
        postcode: ""
      });
    },
    makeReservationCallback(resp) {
      if (resp.code == 0) {
        this.clientSecret = resp.data.clientSecret;
        this.initialize();
      } else {
      }
    },
    async initialize() {
      this.checkout = await this.stripe.initEmbeddedCheckout({
        clientSecret: this.clientSecret
      });
      this.checkout.mount("#checkout");
      this.checkoutDisplayed = true;
    },
    populateDefaultLegalFields() {
      const defaultDetails = {
        companyName: "Elite Conveyancing",
        person: "Maria Mignone",
        firstName: "Maria",
        lastName: "Mignone",
        address: "78A Luhrs Road",
        suburb: "Firle",
        state: "South Australia",
        postcode: "5070",
        openState: false,
        email: "maria@eliteconveyancing.net.au",
        mobile: "0452094296",
        phone: ""
      };
      const defaultOtherStates = {
        companyName: "Bond Conveyancing Pty Ltd",
        address: "Level 10, 369 Royal Parade",
        suburb: "Parkville",
        state: "Victoria",
        postcode: "3052",
        openState: false,
        email: "hello@bondc.com.au",
        mobile: "",
        phone: "1300039559"
      };
      if (this.isSA()) {
        Object.assign(this.reservationForm.legal, defaultDetails);
      } else {
        Object.assign(this.reservationForm.legal, defaultOtherStates);
      }
    },
    clearLegalFields() {
      const emptyDetails = {
        companyName: "",
        person: "",
        firstName: "",
        lastName: "",
        address: "",
        suburb: "",
        state: "",
        postcode: "",
        openState: false,
        email: "",
        mobile: "",
        phone: ""
      };
      Object.assign(this.reservationForm.legal, emptyDetails);
    },
    isSA() {
      return this.listingDetails.state === "South Australia";
    },
    conveyancerCheckboxToggle() {
      if (!this.checked) {
        this.populateDefaultLegalFields();
      } else {
        this.clearLegalFields();
      }

      if (this.checked) {
        this.clearLegalFields();
      } else {
        this.populateDefaultLegalFields();
      }
    },
    validateNotOnlySpaceInputs(rule, value, callback) {
      if (!value.trim()) {
        callback(new Error("Input cannot be only spaces"));
      } else {
        callback();
      }
    },
    validateOfferAmount(rule, value, callback) {
      if (this.$route.query.type == "1") {
        if (value === "" || value === undefined) {
          callback(new Error("Please enter an offer"));
        } else if (!value.toString().trim()) { // Convert to string to use trim() safely
          callback(new Error("Input cannot be only spaces"));
        } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
          callback(new Error("Please input a valid offer amount"));
        } else if (value > 999000000000) {
          callback(new Error('Offer amount cannot exceed 999 billion'));
        } else {
          callback();
        }
      } else if (value !== null && value !== undefined && value !== "") { // Validate if value is entered when not mandatory
        if (!/^\d+(\.\d{1,2})?$/.test(value)) {
          callback(new Error("Please input a valid offer amount"));
        } else if (value > 999000000000) {
          callback(new Error('Offer amount cannot exceed 999 billion'));
        } else {
          callback();
        }
      }
      else {
        callback(); // Not mandatory and no value entered, validation passes
      }
    },
    submitReservation() {
      var that = this;
      let passed = false;
      this.$refs.reservationForm.validate(valid => {
        if (valid) {
          passed = true;
        } else {
          that.$box.alert("", "Please fill the mandatory fields", "error");
          passed = false;
        }
      });
      if (!passed) {
        return;
      }
      var ordersPurchaserVOList = [];
      this.reservationForm.allPurchaser.forEach(v => {
        ordersPurchaserVOList.push({
          address: v.address,
          email: v.email,
          firstName: v.firstName,
          middleName: v.middleName,
          gender: v.title,
          mobile: v.mobile,
          state: v.state,
          suburb: v.suburb,
          surName: v.surName,
          postCode: v.postcode
        });
      });
      var ordersPurchaserLegalVO = {
        address: that.reservationForm.legal.address,
        companyName: that.reservationForm.legal.companyName,
        contactPerson: that.reservationForm.legal.person,
        email: that.reservationForm.legal.email,
        mobile: that.reservationForm.legal.mobile,
        phone: that.reservationForm.legal.phone,
        state: that.reservationForm.legal.state,
        suburb: that.reservationForm.legal.suburb,
        postCode: that.reservationForm.legal.postcode
      };
      // 8848
      let month = that.reservationForm.payment.exp.slice(0, 2);
      let year = that.reservationForm.payment.exp.slice(2, 4);
      let arr = [];
      if (that.reservationForm.payment.exp.indexOf("/") != -1) {
        arr = that.reservationForm.payment.exp.split("/");
        month = arr[0];
        year = arr[1];
      }
      var OrdersBookVO = {
        depositPayingMethod: that.reservationForm.depositPayingMethod,
        bondPartnerInfo: that.reservationForm.infoFromDepositBondPartner,
        colourSchemeCollection: that.reservationForm.colourSchemeCollection,
        additionalComments: that.reservationForm.additionalComments,
        ordersCardbagVO: {
          cardCvv: that.reservationForm.payment.cvv,
          cardName: that.reservationForm.payment.cardName,
          cardNumber: that.reservationForm.payment.cardNumber,
          expMonth: month,
          expYear: year
        },
        ordersPurchaserLegalVO: ordersPurchaserLegalVO,
        ordersPurchaserVOList: ordersPurchaserVOList,
        purchasingEntity:
          that.purchasingEntity.replace(/\s+/g, "") == ""
            ? ""
            : that.purchasingEntity,
        makeOfferAmount: that.reservationForm.payment.offerAmount,
        ordersType: that.$route.query.type == "1" ? "Make Offer" : "Select Now",
        propertyId: that.$route.query.pid,
        roomId: that.$route.query.rid,
        stripeSessionId: that.$route.query.session_id,
        sessionId:  that.privateMode ? sessionStorage.getItem("unifi_sessionId") : null
      };
      if (this.$route.query.type == "1" || this.$route.query.session_id) {
        that.$box.loadings();
        that.submitReservationInfo({
          params: OrdersBookVO,
          callback: that.submitCallback
        });
      } else if (this.$route.query.type == "2") {
        this.stripe = Stripe(process.env.VUE_APP_STRIPE);
        that.makeReservation({
          params: OrdersBookVO,
          callback: this.makeReservationCallback
        });
      }
    },
    destroy() {
      if (this.checkout) {
        this.checkout.unmount();
        this.checkout.destroy();
      }
    },
    submitCallback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.code === 0) {
        if (that.privateMode) {
          that.$router.push({ path: "/private/u-connect/property/reserve/confirm" });
        }else {
          that.$router.push({ path: "/u-connect/property/reserve/confirm" });
        }
      } else if (
        res.code === 90000 ||
        res.code === 90002 ||
        res.code === 90001
      ) {
        localStorage.clear();
        if (that.privateMode) {
          that.$router.push("/private/login");
        }else {
          that.$router.push("/login");
        }
      } else if (res.code == 8902 || res.code == 8901) {
        that.$box.alert("", res.message, "error");
        localStorage.clear();
        if (that.privateMode) {
          that.$router.push("/private/login");
        }else {
          that.$router.push("/login");
        }
      } else if (res.code == 70020) {
        that
          .$confirm("Property has expired", "error", {
            distinguishCancelAndCLOse: true,
            confirmBUttonText: "Back to Home"
          })
          .then(() => {
            that.$router.replace("/");
          })
          .catch(action => {
          });
      } else {
        that.$box.alert("", res.message, "error");
      }
    },
    getOfferType() {
      let totalprice = this.listingDetails.price;
      let totalpriceMax = this.listingDetails.maxPrice;
      let type = "Make Offer";

      if (totalprice && totalpriceMax && totalprice == totalpriceMax) {
        type = "Select now"; //fixed price
      } else if (totalprice && totalpriceMax) {
        type = "Make Offer"; //ranged
      } else if (totalprice && totalpriceMax == null) {
        type = "Select now"; //fixed price
      } else if (totalprice == null && totalpriceMax == null) {
        type = "Make Offer"; //no price
      } else if (totalprice && totalpriceMax == 0) {
        type = "Select now"; //fixed price
      }
      return type;
    },
    displayPrice() {
      let price = this.listingDetails.price;
      let priceMax = this.listingDetails.maxPrice;

      const formatPrice = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };

      if ((price == null && priceMax == null) ||
        (price == 0 && priceMax == 0) ||
        (price == '' && priceMax == '') ||
        (price == 0 && priceMax == null) ||
        (price == null && priceMax == 0)) {
        return 'TBA';
      }
      else if ((parseInt(price) > 0 && priceMax == null)) {
        return '$' + formatPrice(price);
      }
      else if (parseInt(price) > 0 && parseInt(priceMax) > 0) {
        return '$' + formatPrice(price) + ' - ' + '$' + formatPrice(priceMax);
      }
      else if (price == null && parseInt(priceMax) > 0) {
        return '$' + formatPrice(priceMax);
      } else {
        return parseInt(price) > parseInt(priceMax) ?
          '$' + formatPrice(price) :
          '$' + formatPrice(price) + ' - ' + '$' + formatPrice(priceMax);
      }
    }
  },
  watch: {
    listingDetails: {
      handler(newVal) {
        if (newVal && newVal.state) {
          this.populateDefaultLegalFields();
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeUpdate() {
    if (this.$route.path.slice(0,9) === '/private/') {
      this.privateMode = true;
    }
    console.log("Private Submint Reservation", this.$route.query);
    if (this.$route.query.session_id != null) {
      this.submitReservation();
    }
  }
};
</script>

<template>
  <el-row>
    <el-col :span="24" style="padding: 80px 40px 20px 40px">
      <el-row>
        <el-col :span="24">
          <div
              style="border: 4px solid #cccccc; border-radius: 30px; padding: 20px;"
          >
            <el-row>
              <el-col :span="24" class="d-flex jc-center">
                <span class="color-green text-w600 text-dino text-40">Reservation Form</span>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="24" class="d-flex jc-center ac-center">
            <span class="text-dino text-w600 text-36 color-green"
            >{{ listingDetails.apt }} / {{ listingDetails.address }},
              {{ listingDetails.suburb }}</span>
                <el-divider direction="vertical" style="padding: 0 5px;"></el-divider>
                <span class="text-dino text-w400 text-36 color-green"
                >{{ listingDetails.state }} {{ listingDetails.postcode }}</span>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col
                  v-if="this.getOfferType() == 'Select now'"
                  :span="24"
                  style="display: flex; justify-content: center"
              >
            <span class="listing-price-state" style="margin-top: 0">{{ displayPrice(listingDetails) }}</span>
                <el-divider v-if="listingDetails.price != 0" direction="vertical" class="mlf-30"></el-divider>
                <span class="chip-gray">{{ listingDetails.propertyType }}</span>
              </el-col>
              <el-col
                  v-else
                  :span="24"
                  style="display: flex; justify-content: center">
                <span class="listing-price-state" style="margin-top: 0">
                  {{ displayPrice(listingDetails) }}
                </span>
                <el-divider direction="vertical" class="mlf-30"></el-divider>
                <span class="chip-gray">{{ listingDetails.propertyType }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col
                  v-if="$route.query.type == '2'"
                  :span="24"
                  style="margin-top: 20px; line-height: 1.5"
              >
                <el-row style="margin-top: 20px">
                  <el-col :span="24" class="d-flex jc-center">
                    <span class="text-22 text-w400 text-dino text-center">
                      1. Complete the online form with all details of the purchaser and
                      conveyancer or solicitor. Please complete all details carefully as
                      they will be used to prepare the contract of sale and enable the Concierge service to contact your client to progress the sale.
                    </span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24" class="d-flex jc-center">
                    <span class="text-22 text-w400 text-dino text-center">
                      2. Click “Pay and Submit Reservation” to pay the $1,000
                      reservation fee securely online.
                    </span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24" class="d-flex jc-center">
                    <span class=" text-22 text-w400 text-dino text-center">
                      3. Once your reservation is received, the Concierge Service will contact you
                      directly to prepare the contract of sale and take you through next
                      steps.
                    </span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24" class="d-flex jc-center">
                    <span class="text-22 text-w400 text-dino text-center">
                      4. Upon the expiry of the 7-day reservation period, your $1,000
                      reservation fee will be refunded to your original method of
                      payment.
                    </span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
        <el-form
          ref="reservationForm"
          :model="reservationForm"
          :rules="reservationFormRules"
        >
          <el-row>
            <el-col :span="24" style="margin-top: 20px">
              <span class="title-reservation-section">Purchaser Details</span>
            </el-col>
            <div
              v-for="(purchaser, index) in reservationForm.allPurchaser"
              :key="index"
            >
              <el-row>
                <el-col :span="24" style="margin-top: 10px">
                  <span class="title-purchaser-section"
                    >Purchaser #{{ purchaser.purchaserId }}</span
                  >
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top: 20px">
                <el-col :span="6">
                  <el-form-item :prop="'allPurchaser.' + index + '.title'">
                    <el-select
                      v-model="purchaser.title"
                      placeholder="Title"
                      style="display: inline"
                    >
                      <el-option
                        v-for="t in titles"
                        :key="t.id"
                        :label="t.title"
                        :value="t.title"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item :prop="'allPurchaser.' + index + '.firstName'">
                    <el-input
                      v-model="purchaser.firstName"
                      placeholder="First name"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item>
                    <el-input
                      v-model="purchaser.middleName"
                      placeholder="Middle names"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :prop="'allPurchaser.' + index + '.surName'">
                    <el-input
                        v-model="purchaser.surName"
                        placeholder="Surname"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :prop="'allPurchaser.' + index + '.address'">
                    <el-input
                      v-model="purchaser.address"
                      placeholder="Address"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :prop="'allPurchaser.' + index + '.suburb'">
                    <el-input
                        v-model="purchaser.suburb"
                        placeholder="Suburb"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :prop="'allPurchaser.' + index + '.state'">
                    <el-select
                      v-model="purchaser.state"
                      placeholder="State"
                      style="display: inline"
                    >
                      <el-option
                        v-for="state in listingStates"
                        :key="state.id"
                        :label="state.stateName"
                        :value="state.stateName"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :prop="'allPurchaser.' + index + '.postcode'">
                    <el-input
                      v-model="purchaser.postcode"
                      placeholder="Postcode"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item>
                    <el-input
                      v-model="purchaser.mobile"
                      placeholder="Phone"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :prop="'allPurchaser.' + index + '.email'">
                    <el-input
                        v-model="purchaser.email"
                        placeholder="Email"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row>
              <el-col
                :span="24"
                style="display: flex; justify-content: center"
              >
                <el-form-item>
                  <el-button class="color-green btn-add-purchaser"
                    style="justify-content: center; border-bottom: 1px solid #003333; padding-bottom: 2px;"
                    type="text"
                    @click="addAnotherPurchaser"
                  >
                    Add another purchaser's details
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" >
                <el-form-item>
                  <el-input
                    v-model="purchasingEntity"
                    placeholder="Purchasing entity"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="text-dino text-18 text-w400"
                  >Only complete if you are purchasing outside of your personal
                  name</span
                >
              </el-col>
            </el-row>
            <el-row v-if="$route.query.type == '1'" style="margin-top: 20px">
              <el-col :span="24" >
                <span class="title-reservation-section">Make an offer</span>
              </el-col>
            </el-row>
            <el-row v-if="$route.query.type == '1'" style="margin-top: 10px">
              <el-col :span="24">
                <el-form-item prop="payment.offerAmount">
                  <el-input
                    v-model.number="reservationForm.payment.offerAmount"
                    placeholder="Make an offer"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-top: 25px">
              <el-col :span="24" >
                <span class="title-reservation-section"
                  >Deposit</span
                >
              </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
              <el-col :span="24" class="mb-10">
                <span class="text-dino text-18 text-w400">How will your client pay their deposit?</span>
              </el-col>
              <el-col :span="24" >
                <el-form-item prop="depositPayingMethod">
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-radio-group v-model="reservationForm.depositPayingMethod" class="vertical-radio-group" style="width: 100%; padding: 5px 0">
                        <el-radio :label="DEPOSIT.CASH_TRANSFER.value" border>{{ DEPOSIT.CASH_TRANSFER.label }}</el-radio>
                      </el-radio-group>
                    </el-col>
                    <el-col :span="6">
                      <el-radio-group v-model="reservationForm.depositPayingMethod" class="vertical-radio-group" style="width: 100%; padding: 5px 0">
                        <el-radio :label="DEPOSIT.BANK_GUARANTEE.value" border >{{ DEPOSIT.BANK_GUARANTEE.label }}</el-radio>
                      </el-radio-group>
                    </el-col>
                    <el-col :span="12">
                      <el-radio-group v-model="reservationForm.depositPayingMethod" class="vertical-radio-group" style="width: 100%; padding: 5px 0">
                        <el-radio :label="DEPOSIT.DEPOSIT_BOND.value" border >{{ DEPOSIT.DEPOSIT_BOND.label }}</el-radio>
                      </el-radio-group>
                      <div class="deposit-bond-description">
                        <span style="color: #647979"><em>(Deposit bonds can replace cash and help buyers secure property sooner – <a href="https://www.downsizer.com/agents_u-connect" target="_blank" class="text-dino">click here</a> to find out more)</em></span>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item prop="infoFromDepositBondPartner">
                  <el-row :gutter="20">
                    <el-col :span="24" style="margin-top: 3vh">
                      <el-checkbox v-model="reservationForm.infoFromDepositBondPartner" :label="DEPOSIT.DEPOSIT_BOND_INFO.label" border></el-checkbox>
                      <div class="deposit-bond-description">
                        <span style="color: #647979"><em>{{ DEPOSIT.DEPOSIT_BOND_INFO.description }}</em></span>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 10px">
              <el-col span="12">
                <span class="color-green text-w400 text-dino text-18">Colour scheme collection</span>
                <el-form-item prop="colourSchemeCollection">
                  <el-input style="margin-top: 5px"
                    v-model="reservationForm.colourSchemeCollection"
                    placeholder="Colour scheme collection"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <span class="color-green text-w400 text-dino text-18">Additional comments for contract instructions</span>
                <el-form-item prop="additionalComments">
                  <el-input style="margin-top: 5px"
                            v-model="reservationForm.additionalComments"
                            placeholder="Additional comments"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 10px">
              <el-col span="24">
                <p class="instruction-text">
                  Please send a copy of your Driver’s License or Passport to
                  <a href="mailto:team@unifiproperty.com" class="email-link">team@unifiproperty.com</a>
                </p>
              </el-col>
            </el-row>
            <el-row style="margin-top: 20px">
              <el-col :span="24" >
                <span class="title-reservation-section"
                  >Purchaser's Conveyancer / Solicitor</span>
              </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
              <el-col :span="24" >
                <el-form-item>
                  <el-checkbox
                    v-model="checked"
                    style="display: flex; align-items: center"
                    @change="conveyancerCheckboxToggle"
                  >
                    <span class="color-green text-w400 text-dino text-18">Please check the box if you would like to nominate a
                      different conveyancer or solicitor and complete the
                      fields below</span
                    >
                  </el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.companyName"
                    placeholder="Company Name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.email"
                    placeholder="Email"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.address"
                    placeholder="Address"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-input
                      v-model="reservationForm.legal.suburb"
                      placeholder="Suburb"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item>
                  <el-select
                    v-model="reservationForm.legal.state"
                    placeholder="State"
                    style="display: inline"
                  >
                    <el-option
                      v-for="state in listingStates"
                      :key="state.id"
                      :label="state.stateName"
                      :value="state.stateName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-input
                    v-model="reservationForm.legal.postcode"
                    placeholder="Postcode"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item>
                  <el-input
                      v-model="reservationForm.legal.phone"
                      placeholder="Landline"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-input
                      v-model="reservationForm.legal.mobile"
                      placeholder="Mobile"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col  :span="24">
                <span class="title-reservation-section">Agent's Details</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col  :span="24" style="margin-top: 10px">
                <el-form-item class="mb-0">
                  <el-col
                      :span="24"
                      class="text-dino text-20 color-green">
                    <span class="text-w600">Company Name</span>
                    <el-divider direction="vertical" class="mlf-5"></el-divider>
                    <span class="text-w400">{{ listingDetails.agencyDetails.name }}</span>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item class="mb-0">
                  <el-col
                      :span="24"
                      class="text-dino text-20 color-green">
                    <span class="text-w600">Contact Person</span>
                    <el-divider direction="vertical" class="mlf-5"></el-divider>
                    <span v-for="(agent, index) in listingDetails.agentsDetails"
                          :key="index"
                          class="text-w400">{{agent.firstName.trim() }} {{ agent.lastName.trim()}}<span v-if="index < listingDetails.agentsDetails.length - 1">, </span>
                    </span>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item class="mb-0">
                  <el-col
                      :span="24"
                      class="text-dino text-20 color-green">
                    <span class="text-w600">Address</span>
                    <el-divider direction="vertical" class="mlf-5"></el-divider>
                    <span class="text-w400">{{ listingDetails.agencyDetails.address.trim() }}, {{listingDetails.agencyDetails.suburb.trim() }} {{listingDetails.agencyDetails.state.trim() }} {{listingDetails.agencyDetails.postcode.trim() }}</span>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item class="mb-0">
                  <el-col
                      :span="24"
                      class="text-dino text-20 color-green">
                    <span class="text-w600">Phone Number</span>
                    <el-divider direction="vertical" class="mlf-5"></el-divider>
                    <span v-for="(agent, index) in listingDetails.agentsDetails"
                          :key="index"
                          class="text-w400">{{ agent.phoneNumber.trim()}}<span v-if="index < listingDetails.agentsDetails.length - 1">, </span>
                    </span>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item class="mb-0">
                  <el-col
                      :span="24"
                      class="text-dino text-20 color-green">
                    <span class="text-w600">Email</span>
                    <el-divider direction="vertical" class="mlf-5"></el-divider>
                    <span v-for="(agent, index) in listingDetails.agentsDetails"
                          :key="index"
                          class="text-w400">{{ agent.email }}<span v-if="index < listingDetails.agentsDetails.length - 1">, </span>
                    </span>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row
              v-if="listingDetails.price != 0 && $route.query.type == '2'"
            >
              <el-col id="checkout" ref="checkout" :span="24">
              </el-col>

              <el-col
                v-if="checkoutDisplayed"
                :span="24"
                style="margin-top: 10px"
              >
                <span class="text-dino text-20 text-w400"
                  >Please note the $1000 reservation fee is fully refunded to
                  you after a 7 day holding period. Please note that it may take
                  3-5 business days for the reimbursed funds to clear in your
                  account. An additional transactional fee of 3% + 30c for
                  domestic and international cards is a non-refundable
                  fee.</span
                >
              </el-col>
              <el-col
                v-if="checkoutDisplayed"
                :span="24"
                style="margin-top: 10px"
              >
                <span class="text-dino text-20 text-w400"
                  >Secure payment transactions powered by Stripe and secure with
                  256-bit encryption</span
                >
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col
                :span="24">
                <el-button
                  v-if="$route.query.type == '1'"
                  class="btn-pay-submit btn-offer-p"
                  @click="submitReservation">
                  <span class="text-w400 text-dino text-22">Submit Offer</span>
                </el-button>
                <el-button
                  v-if="$route.query.type == '2' && !checkoutDisplayed"
                  class="btn-pay-submit btn-select-p"
                  @click="submitReservation">
                  <span class="text-w400 text-dino text-22">Pay and Submit Reservation</span>
                </el-button>
              </el-col>
            </el-row>
            <el-row  style="margin-top: 10px">
              <el-col :span="24">
                <span
                    v-if="$route.query.type == '2'"
                    class="text-dino text-22 text-w400">Congratulations on your property reservation. Your real
                  estate agent will be in touch shortly.</span>
                <span
                    v-if="$route.query.type == '1'"
                    class="text-dino text-22 text-w400">Congratulations. Your real estate agent will be in touch
                  shortly.</span>
              </el-col>
            </el-row>
          </el-row>
        </el-form>
    </el-col>
  </el-row>
</template>

<style scoped>
.para-form-selection {
  color: #003333;
  font: 400 18px DINosaur-a, sans-serif;
  display: flex;
}

.btn-pay-submit {
  border-top-right-radius: 30px;
  border-width: 0;
  background: #003333;
  color: #ffffff;
}
.btn-offer-p {
  padding: 10px 100px;
}
.btn-select-p {
  padding: 10px 60px;
}

.chip-gray {
  color: #003333;
  white-space: nowrap;
  justify-content: center;
  border-radius: 10px;
  background-color: #cccccc;
  padding: 10px 20px;
  font: 400 16px/125% DINosaur-a, sans-serif;
}

.listing-price-state {
  font-feature-settings: "clig" off, "liga" off;
  margin-top: 12px;
  font: 400 34px/118% DINosaur-a, sans-serif;
  color: #003333;
}

.title-reservation-section {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font: 600 30px DINosaur-a, sans-serif;
}

.title-purchaser-section {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font: 600 20px DINosaur-a, sans-serif;
}
.el-checkbox {
  .el-checkbox__label {
    font-size: 18px;
    color: #003333;
  }
}
.text-16 {
  font-size: 16px;
}
.text-18 {
  font-size: 18px;
}
.text-20 {
  font-size: 20px;
}
.text-22 {
  font-size: 22px;
}
.text-24 {
  font-size: 24px;
}
.text-36 {
  font-size: 36px;
}
.text-40 {
  font-size: 40px;
}
.text-dino {
  font-family: DINosaur-a, sans-serif;
}
.text-w400 {
  font-weight: 400;
}
.text-w600 {
  font-weight: 600;
}
.text-center {
  text-align: center;
}
.text-w700 {
  font-weight: 700;
}
.color-green {
  color: #003333;
}
.color-white {
  color: #ffffff;
}
.color-gray {
  color: #cccccc;
}
.d-flex {
  display: flex;
}
.jc-center {
  justify-content: center;
}
.ac-center{
  align-content: center;
}
.el-divider--vertical {
  width: 4px;
  font-size: 40px;
}
.el-divider {
  background-color: #003333;
}
.mlf-30 {
  margin: 0 30px;
}
.mlf-5 {
  margin: 0 5px;
}
.mb-0 {
  margin-bottom: 0;
}
.mb-10 {
  margin-bottom: 10px;
}
.el-divider--vertical.mlf-5 {
  width: 2px;
  font-size: 20px;
}
.btn-add-purchaser {
  font-size: 20px;
  transition: font-size 0.3s ease-in-out;
}
.btn-add-purchaser:hover {
  font-size: 21px;
}
.el-select-dropdown__item {
  color: #003333 !important;
  background-color: #ffffff !important;
}
.el-select-dropdown__item:hover {
  color: #ffffff !important;
  background-color: #003333 !important;
}
.vertical-radio-group >>> .el-radio.is-bordered {
  display: block;
  width: 100%;
  margin-left: 0 !important;
  margin-bottom: 15px;
}
.vertical-radio-group >>> .el-radio.is-bordered:last-of-type {
  margin-bottom: 0;
}
.deposit-bond-description {
  font-family: DINosaur-a, sans-serif;
  font-weight: 400;
  color: #003333;
  padding-left: 28px;
  line-height: 1.4;
  display: block;
}
.deposit-bond-description a {
  color: #003333;
  text-decoration: underline;
}
.el-radio:last-of-type{
  width: 100%;
}
.el-radio.is-bordered.is-checked {
  border-color: #003333;
  background-color: rgba(128, 174, 158, 0.9);
  color: #ffffff;
}
.el-radio.is-checked /deep/ .el-checkbox__label {
  color: #003333;
}

.el-checkbox:last-of-type{
  width: 100%;
}
.el-checkbox.is-bordered.is-checked {
  border-color: #003333;
  background-color: rgba(128, 174, 158, 0.9);
  color: #ffffff;
}
.el-checkbox.is-checked /deep/ .el-checkbox__label {
  color: #003333;
}
.instruction-text {
  color: #003333; /* or your color-green */
  font-weight: 400;
  font-size: 20px;
}

.email-link {
  color: inherit;
  text-decoration: underline;
  font-style:italic;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/uConnectReservation/reservationFormSection.vue